import { render } from "./BookableLockingAttributes.vue?vue&type=template&id=3bcf3b72&scoped=true"
import script from "./BookableLockingAttributes.vue?vue&type=script&lang=js"
export * from "./BookableLockingAttributes.vue?vue&type=script&lang=js"

import "./BookableLockingAttributes.vue?vue&type=style&index=0&id=3bcf3b72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcf3b72"]])

export default __exports__